<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.name" :label="filtersLabel.name" :error-messages="errors.collect('name')" data-vv-name="name" :data-vv-as="filtersLabel.name" v-validate="'name|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.nricPassport" :label="filtersLabel.nricPassport" :error-messages="errors.collect('nricPassport')" data-vv-name="nricPassport" :data-vv-as="filtersLabel.nricPassport" v-validate="'alpha_num|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
        <template slot="items" slot-scope="props">
          <td v-for="column in columns" :key="column.value">
            {{props.item[column.value]}}
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="canReview(props)" :query="checkAccess(['travelQuote' , 'travelQuoteQuery'])" @query="doQuery(props)" @review="doReview(props)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import clone from 'clone'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber } from '@/utils/number'
import { expandURI, filterQuery } from '@/utils/ajax'
import { removeTime, setEndTime, formatDisplayDateTime2, formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      columns: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Name', value: 'name' },
        { text: 'Date of Birth', value: 'dob' },
        { text: 'NRIC/Passport', value: 'nricPassport' },
        { text: 'Entry Date', value: 'createdDate' }
      ],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        name: 'Name',
        nricPassport: 'NRIC/Passport',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To'
      },
      filters: {
        proposalNo: null,
        name: null,
        nricPassport: null,
        entryFrom: null,
        entryTo: null
      },
      showDetailFilters: false,
      totalItems: 0
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listHeaders() {
      return [...this.columns, TableConst.tableActionHeader]
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData()
    },
    'pagination.page': function (value) {
      this.fetchData()
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData()
    },
    'pagination.sortBy': function (value) {
      this.fetchData()
    }
  },
  methods: {
    async fetchData() {
      const apiUrl = this.$store.state.agency.listing.menu.travelInsureds
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((quote) => {
                const convertQuote = {
                  proposalNo: quote.proposalNo,
                  seqNo: quote.seqNo,
                  name: quote.name,
                  dob: this.formatDate(quote.dob),
                  nricPassport: quote.nricPassport,
                  status: quote.status,
                  createdDate: this.formatDate(quote.createdDate)
                }
                this.items.push(convertQuote)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.name = null
      this.filters.nricPassport = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    formatNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    canReview(data) {
      if (this.checkAccess(['travelQuote'])) {
        if (data.item.status === 'NQ') {
          return true
        }
      }
      return false
    },
    doQuery(data) {
      this.$router.push({ name: 'travelQuoteQuery', params: { id: data.item.proposalNo } })
    },
    async doReview(data) {
      try {
        this.loading = true
        const dispatchObj = {
          proposalNo: data.item.proposalNo,
          query: false
        }
        await this.$store.dispatch('loadQuote', dispatchObj)

        // Check status and redirect to the correct page
        if (data.item.statusCode === 'NQ') {
          this.$router.push({ name: 'travelQuote' })
        } else {
          this.$snotify.error('Invalid Status Code')
        }

        // Dont have to set loading to false here. It should have been redirected
        // If somehow error occurs, by right they cant try to load again. Might have dirty data now
        // this.loading = false
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
